import { createFileRoute, redirect } from '@tanstack/react-router'

import { queryClient } from '@/api/api'
import { getTaxonomyOptions } from '@/api/codegen/@tanstack/react-query.gen'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/',
)({
  beforeLoad: async ({ params: { companyId, spaceId, taxonomyId } }) => {
    const taxonomy = await queryClient.ensureQueryData(
      getTaxonomyOptions({
        path: {
          spaceID: spaceId,
          taxonomyID: taxonomyId,
        },
      }),
    )

    throw redirect({
      to: '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId',
      params: {
        companyId,
        spaceId,
        taxonomyId,
        taxonomyVersionId: taxonomy.taxonomyVersion.id,
      },
    })
  },
})
